import React from "react";

import { ProcedureDetail } from "../user";

export default function Detail(props) {
  return <ProcedureDetail isAdmin {...props} />;
}
